module.exports = __webpack_public_path__ + "media/images/emblems/CHE_Val_de_Bagnes_COA-768439597cb2af6fa3120871f08a63cb.svg";